/**
 * Types d'Articles selon DGI Burkina Faso - Section §7.5
 * Reference: Specifications Techniques SFE v2.0
 * Arrete n°2025-0047/MEF/SG/DGI (05 fevrier 2025)
 *
 * Les articles sont classifies selon leur origine (local/importe)
 * et leur nature (bien/service). Chaque type determine la mention
 * obligatoire sur facture.
 *
 * Types requis par DGI §7.5:
 * - LOCBIE: Bien local
 * - LOCSER: Service local
 * - IMPBIE: Bien importe
 * - IMPSERV: Service importe
 */
/**
 * Types d'articles conformes a DGI §7.5
 *
 * | Code    | Type                   | Mention Facture |
 * |---------|------------------------|-----------------|
 * | LOCBIE  | Bien (Local)           | [LOCBIE]        |
 * | LOCSER  | Service (Local)        | [LOCSER]        |
 * | IMPBIE  | Bien (Importation)     | [IMPBIE]        |
 * | IMPSERV | Service (Importation)  | [IMPSER]        |
 */
export const ARTICLE_TYPES = {
    /**
     * LOCBIE - Bien local
     * Produit physique fabrique ou acquis localement au Burkina Faso
     */
    LOCBIE: {
        code: "LOCBIE",
        label: "Bien (Local)",
        invoiceMention: "[LOCBIE]",
        isImported: false,
        isService: false,
        description: "Produit physique local (fabriqué ou acquis au Burkina Faso)",
    },
    /**
     * LOCSER - Service local
     * Prestation de service fournie localement au Burkina Faso
     */
    LOCSER: {
        code: "LOCSER",
        label: "Service (Local)",
        invoiceMention: "[LOCSER]",
        isImported: false,
        isService: true,
        description: "Prestation de service locale (fournie au Burkina Faso)",
    },
    /**
     * IMPBIE - Bien importe
     * Produit physique importe de l'etranger
     */
    IMPBIE: {
        code: "IMPBIE",
        label: "Bien (Importation)",
        invoiceMention: "[IMPBIE]",
        isImported: true,
        isService: false,
        description: "Produit physique importé (provenant de l'étranger)",
    },
    /**
     * IMPSERV - Service importe
     * Prestation de service provenant de l'etranger
     * Note: La mention facture est [IMPSER] selon DGI §7.5
     */
    IMPSERV: {
        code: "IMPSERV",
        label: "Service (Importation)",
        invoiceMention: "[IMPSER]",
        isImported: true,
        isService: true,
        description: "Prestation de service importée (provenant de l'étranger)",
    },
};
/** All article type codes (LOCBIE, LOCSER, IMPBIE, IMPSERV), for z.enum(). */
export const ARTICLE_TYPE_CODES = Object.keys(ARTICLE_TYPES);
/**
 * Codes d'unites de mesure couramment utilises
 */
export const UNIT_CODES = {
    /** Unite - Unit */
    U: { code: "U", label: "Unité" },
    /** Kilogramme */
    KG: { code: "KG", label: "Kilogramme" },
    /** Gramme */
    G: { code: "G", label: "Gramme" },
    /** Litre */
    L: { code: "L", label: "Litre" },
    /** Millilitre */
    ML: { code: "ML", label: "Millilitre" },
    /** Metre */
    M: { code: "M", label: "Mètre" },
    /** Metre carre */
    M2: { code: "M2", label: "Mètre carré" },
    /** Metre cube */
    M3: { code: "M3", label: "Mètre cube" },
    /** Heure */
    H: { code: "H", label: "Heure" },
    /** Jour */
    J: { code: "J", label: "Jour" },
    /** Mois */
    MOIS: { code: "MOIS", label: "Mois" },
    /** Forfait */
    FF: { code: "FF", label: "Forfait" },
    /** Piece */
    PC: { code: "PC", label: "Pièce" },
    /** Carton */
    CT: { code: "CT", label: "Carton" },
    /** Palette */
    PAL: { code: "PAL", label: "Palette" },
};
/**
 * Recupere un type d'article par son code
 */
export function getArticleType(code) {
    return ARTICLE_TYPES[code];
}
/**
 * Verifie si un type d'article peut etre soumis a la TSB (Taxe Speciale sur les Boissons)
 * La TSB s'applique aux biens et services lies aux boissons
 */
export function canHaveTSB(_articleType) {
    // Tous les types d'articles peuvent avoir la TSB quand il s'agit de boissons
    return true;
}
/**
 * Categories de boissons pour la determination du PSVB
 */
export const BEVERAGE_CATEGORIES = {
    /** Boissons alcoolisees */
    ALCOHOLIC: {
        code: "ALCOHOLIC",
        label: "Boissons alcoolisées",
        examples: ["Bière", "Vin", "Spiritueux", "Liqueurs"],
    },
    /** Boissons non alcoolisees */
    NON_ALCOHOLIC: {
        code: "NON_ALCOHOLIC",
        label: "Boissons non alcoolisées",
        examples: ["Jus de fruits", "Sodas", "Eau minerale", "The glace"],
    },
};
//# sourceMappingURL=article-types.js.map